import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';
const ExportExcel = async (json , fileName, options = {})=>{
    const ws = XLSX.utils.json_to_sheet(json, {skipHeader: options.skipHeader === true});
    if (options.wrapText) {
        Object.keys(ws).filter((key) => !key.startsWith('!')).forEach((key) => {
            const cell = ws[key];
            cell.s = {...cell.s, alignment: {...cell.s?.alignment, wrapText: true, vertical: 'top'}};
        });
        ws['!cols'] = Object.keys(json[0] || {}).map((header) => ({
            wch: Math.min(45, Math.max(18, header.length + 2)),
        }));
    }
    const wb = {Sheets : {'data' : ws} , SheetNames : ['data']};
    if (options.rtl) {
        wb.Workbook = {Views : [{RTL : true}]};
    }
    const excelBuffer = XLSX.write(wb,{bookType :'xlsx',type:'array',compression:true});
    const data = new Blob([excelBuffer], {type :fileType});
    FileSaver.saveAs(data , fileName + fileExtension)
}
export const ExportExcelFromTable = (tableId , fileName)=>{
    var elt = document.getElementById(tableId);
    var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
    return XLSX.writeFile(wb, fileName + '.xlsx', {compression:true});
}
export default ExportExcel;
